import { render, staticRenderFns } from "./nipigeloader.vue?vue&type=template&id=74c32b09&"
import script from "./nipigeloader.vue?vue&type=script&lang=js&"
export * from "./nipigeloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports